import { InjectionToken } from '@angular/core';
import {SocketPort} from "../ports/socket.port";

export const SOCKET_SERVICE = new InjectionToken<SocketPort>('SocketService');
